import React from 'react';
import TextInput from "@/Shared/TextInput";
import TextArea from "@/Shared/TextArea";
import ImageInput from "@/Shared/ImageInput";

const MetaInfoForm = ({data, errors, setData}) => {
  return (
    <div className='flex flex-wrap p-8 -mb-8 -mr-6'>
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Title"
        name="title"
        type="text"
        errors={errors.title}
        value={data.title}
        onChange={e => setData('title', e.target.value)}
      />

      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Keywords"
        name="keywords"
        type="text"
        errors={errors.keywords}
        value={data.keywords}
        onChange={e => setData('keywords', e.target.value)}
      />
      <TextInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="URL"
        name="url"
        type="text"
        errors={errors.url}
        value={data.url}
        onChange={e => setData('url', e.target.value)}
      />
      <TextArea
        className="w-full pb-8 pr-6"
        label="Description"
        name="description"
        errors={errors.description}
        value={data.description}
        onChange={e => setData('description', e.target.value)}
      />
      <ImageInput
        className="w-full pb-8 pr-6 lg:w-1/2"
        label="Page Image"
        name="def_image_logo"
        errors={errors.def_image_logo}
        value={data.def_image_logo}
        onChange={def_image_logo => setData('def_image_logo', def_image_logo)}
      />
    </div>
  );
};

export default MetaInfoForm;
